export class ServiceRequestExternalError extends Error {}
